import { useInView } from '../../../hooks/useInView';

const highlights = [
  {
    icon: 'ri-building-4-line',
    text: 'Atuação especializada e focada em direito imobiliário',
  },
  {
    icon: 'ri-user-heart-line',
    text: 'Atendimento personalizado e estratégico para cada cliente',
  },
  {
    icon: 'ri-shield-check-line',
    text: 'Segurança jurídica em todas as etapas do processo',
  },
];

export default function About() {
  const { ref: leftRef, inView: leftIn } = useInView();
  const { ref: rightRef, inView: rightIn } = useInView();

  return (
    <section id="sobre" className="w-full py-24 md:py-32" style={{ background: '#F5F5F5' }}>
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

        {/* Image */}
        <div
          ref={leftRef}
          className={`transition-all duration-1000 ${leftIn ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
        >
          <div className="relative">
            {/* Gold frame accent */}
            <div
              className="absolute -top-4 -left-4 w-32 h-32 rounded-sm opacity-30"
              style={{ border: '2px solid #D4AF37' }}
            ></div>
            <div
              className="absolute -bottom-4 -right-4 w-32 h-32 rounded-sm opacity-30"
              style={{ border: '2px solid #D4AF37' }}
            ></div>

            <div className="relative w-full h-[300px] md:h-[520px]">
              <img
                src="https://storage.readdy-site.link/project_files/1f1d084b-7826-4e7d-b954-e12cc59853f4/bdf3ef56-9591-4032-bfb4-efaeef584e94_foto-uitalo-melhorada.png?v=9e622b97be732007544e804778bf5f61"
                alt="Uitalo Bruno – Advogado especialista em direito imobiliário"
                className="w-full h-full object-cover object-top rounded-sm"
              />
              {/* Overlay badge */}
              <div
                className="absolute bottom-6 left-6 right-6 py-4 px-5"
                style={{ background: 'rgba(10,42,82,0.92)', borderLeft: '3px solid #D4AF37' }}
              >
                <p className="font-serif text-lg font-semibold" style={{ color: '#F5F5F5' }}>Dr. Uitalo Bruno</p>
                <p className="font-sans text-xs tracking-wider uppercase font-light mt-0.5" style={{ color: '#D4AF37' }}>
                  Especialista em Direito Imobiliário
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div
          ref={rightRef}
          className={`transition-all duration-1000 delay-200 ${rightIn ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}
        >
          {/* Section label */}
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12" style={{ background: '#D4AF37' }}></div>
            <span className="font-sans text-xs tracking-[3px] uppercase font-medium" style={{ color: '#D4AF37' }}>
              Sobre o Escritório
            </span>
          </div>

          <h2 className="font-serif text-3xl md:text-4xl font-bold leading-tight mb-6" style={{ color: '#0A2A52' }}>
            Advocacia com propósito,{' '}
            <em>excelência</em> e resultado.
          </h2>

          <p className="font-sans text-base leading-relaxed mb-4" style={{ color: '#123B73' }}>
            O escritório <strong>Uitalo Bruno Advocacia</strong> nasceu com uma missão clara: oferecer soluções jurídicas estratégicas na área imobiliária, unindo conhecimento técnico aprofundado com atendimento verdadeiramente personalizado.
          </p>

          <p className="font-sans text-sm leading-relaxed mb-8" style={{ color: '#123B73' }}>
            Acreditamos que cada processo é único. Por isso, cada cliente recebe atenção individualizada, com análise detalhada do caso, elaboração de estratégias eficazes e acompanhamento contínuo em todas as etapas.
          </p>

          {/* Highlights */}
          <div className="flex flex-col gap-4">
            {highlights.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-4 p-4 rounded-sm transition-all duration-300"
                style={{ background: 'white', borderLeft: '3px solid #D4AF37' }}
              >
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-sm" style={{ background: '#0A2A52' }}>
                  <i className={`${item.icon} text-lg`} style={{ color: '#D4AF37' }}></i>
                </div>
                <p className="font-sans text-sm leading-relaxed" style={{ color: '#0A2A52' }}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}